import template from './index.html.twig';

Shopware.Component.register('sw-cms-block-moorl-twig', {
    template
});
